import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import { ZigZagHeadingAndAltCtaInitModel,  ZigZagHeadingAndAltCtaInitVariables,
  ZigZagHeadingAndAltCtaModel,
  ZigZagHeadingAndAltCtaVariables, } from '../../../../../models/email-template/zigzag-heading-and-alt-cta.interface';
import { BaseComponent } from '../../../common/BaseComponent';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-zigzag-heading-and-alt-cta',
    imports: [
        CommonModule,
        NotificationComponent,
        ReactiveFormsModule,
        BlockTextComponent,
        PinComponent,
    ],
    templateUrl: './zigzag-heading-and-alt-cta.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './zigzag-heading-and-alt-cta.scss'
})
export class ZigZagHeadingAndAltCtaComponent extends BaseComponent implements OnInit {
  @Input() block: ZigZagHeadingAndAltCtaModel = new ZigZagHeadingAndAltCtaInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      // console.log("ZigZag add init ->")
      this.block.variables = new ZigZagHeadingAndAltCtaInitVariables()
    }
  }

  //placeholders:
  imagePlaceholder: string = 'Image';
  imageHrefPlaceholder: string = 'Enter Image Redirect Link';
  imageAltPlaceholder: string = 'Enter Image Alt Text';
  textPlaceholder: string = 'Enter Text';
  headingPlaceholder: string = 'Enter Heading';
  ctaLinkPlaceholder: string = 'Enter CTA Link';
  ctaTextPlaceholder: string = 'Enter CTA Text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  onChange(value: any, fieldName: keyof ZigZagHeadingAndAltCtaVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof ZigZagHeadingAndAltCtaVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
